import { createSelector } from 'reselect'

const getPartyName = createSelector([data => data], data => {
  return data ? data.name || data.preferred_name : null
})

export { getPartyName }
